<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <h2 class="purple bold">Registros de Aprendizagem</h2>
      </b-col>
      <b-col class="text-right d-flex justify-content-end">
        <b-button
          v-if="!showRdaTable"
          class="btn small blue mr-2"
          @click="triggerRdaAction"
        >
          Voltar
        </b-button>
        <b-button class="btn medium blue" @click="() => $router.go(-1)">
          Voltar para Tela Inicial
        </b-button>
      </b-col>
    </b-row>

    <b-row align="center" v-if="loading">
      <b-col class="mt-5">
        <b-spinner variant="success" label="Carregando..."></b-spinner>
      </b-col>
    </b-row>

    <b-row align="center" style="padding-bottom: 20px">
      <b-col v-if="!selectedSubject || showRdaTable">
        <StudentProfileCard :studentId="student.id" />
      </b-col>
      <b-col v-else>
        <LearningRecordHeader
          :student-photo="student.User.photo"
          :student-name="student.User.name"
          :subject="selectedSubject"
          :cycle="student.Cycle"
          :cycle-year="student.Year.id"
        />
      </b-col>
    </b-row>

    <b-row v-if="this.student !== null">
      <b-col style="padding-left: 30px">
        <h4 class="mb-4">Ciclos</h4>
        <div class="rdaContent">
          <StudentRDAComponent
            :studentId="id"
            :showRdaTable.sync="showRdaTable"
            :selectedSubject.sync="selectedSubject"
            :isParentView="!showForParent || !showForStudent"
          />
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="6">
        <Loading />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import httpRda from "../../http-rda";
import Loading from "../../components/Loading.vue";
import StudentRDAComponent from "../../components/StudentRDAComponent.vue";
import StudentProfileCard from "@/components/StudentProfileCard.vue";
import LearningRecordHeader from "@/components/LearningRecordHeader.vue";
import store from "../../store";

export default {
  name: "dashboard-tutoria-aluno",
  components: {
    Loading,
    StudentRDAComponent,
    StudentProfileCard,
    LearningRecordHeader,
  },

  data() {
    return {
      id: this.$route.params.id,
      loading: false,
      student: null,
      tutoringData: null,
      currentUserId: null,
      showForParent: false,
      showForStudent: false,
      showRdaTable: true,
      selectedSubject: null,
    };
  },

  methods: {
    async getCurrentUser() {
      this.currentUserId = store.getters["auth/getAuthData"];
      this.currentUserId = this.currentUserId.id;

      await this.getStudentParents();
    },

    triggerRdaAction() {
      this.showRdaTable = true;
    },

    async getStudentParents() {
      const parentsIds = await httpRda
        .get(`/tutoring/student/${this.student.id}/parents`)
        .then((response) => response.data.parentsIds);

      const currentUserIsParent = parentsIds.some(
        (p) => p === this.currentUserId
      );

      const currentUserIsStudent = this.student.User.id === this.currentUserId;

      currentUserIsParent
        ? (this.showForParent = false)
        : (this.showForParent = true);

      currentUserIsStudent
        ? (this.showForStudent = false)
        : (this.showForStudent = true);
    },

    async getAllTutoringData() {
      const response = await httpRda.get(
        `/tutoring/student/${this.id}/tutoringData?showForParent=${this.showForParent}&showForStudent=${this.showForStudent}`
      );

      this.tutoringData = response.data.tutoringData;
    },

    async getStudentData() {
      const id = this.id;
      if (id) {
        await httpRda
          .get(`/students/${id}?include=parents,cycle`)
          .then(async (res) => {
            this.student = res.data.student;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },

  async created() {
    await this.getStudentData();
    await this.getCurrentUser();
    await this.getAllTutoringData();
  },
};
</script>

<style>
.container-rda .text-right.d-flex {
  align-items: center;
}
</style>
